module.exports = __webpack_public_path__ + "assets/Alpha.a670e567c1d620a14f58b0ed560bd5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Alpha.png
// module id = 780
// module chunks = 0